<script>
	// Stores
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let race;

	$: race && resetManualReview();

	let manualReview = race && race.in_review ? true : false;

	function resetManualReview() {
		manualReview = race && race.in_review ? true : false;
	}

	function updateManualReview() {
		RaceStore.updateManualReview(race.id, {
			in_review: manualReview
		})
			.then(() => {
				notify({
					type: 'success',
					title: `Race ${race.race_number}`,
					message: `Manual Review updated to ${manualReview ? 'ON' : 'OFF'}`,
					timeout: 3
				});
			})
			.catch(() => {
				notify({
					type: 'danger',
					title: `Race ${race.race_number}`,
					message: 'Failed to update manual review',
					timeout: 3
				});
			});
	}
</script>

<div class="flex items-center p-1 border rounded-md">
	<div class="mr-1">Manual Review</div>
	<Switch on:change={updateManualReview} name={'review' + race.race_number} bind:checked={manualReview} small={true} />
</div>
